import { z } from "zod";

export const loginRequestSchema = z.object({
  is_mobile: z.boolean().default(true),
  recaptcha_response: z.string().min(1, "reCAPTCHA verification is required").or(z.literal("")),
  email: z.string().email("Invalid email format"),
  password: z.string().min(1, "Password is required"),
});

export const loginResponseSchema = z.object({
  response_schema: z.object({
    response_code: z.string(),
    response_message: z.string(),
  }),
  response_output: z.object({
    detail: z.object({
      access_token: z.string(),
      refresh_token: z.string().nullable().optional(),
      token_type: z.string(),
      expires_in: z.number(),
    }),
  }),
});

export const companySchema = z.object({
  id: z.number(),
  name: z.string(),
  logo_file_id: z.number().nullable().optional(),
  zone_id: z.string().nullable().optional(),
});

export const profileResponseSchema = z.object({
  response_schema: z.object({
    response_code: z.string(),
    response_message: z.string(),
  }),
  response_output: z.object({
    detail: z.object({
      id: z.number(),
      user_id: z.number().optional(),
      name: z.string(),
      email: z.string().email(),
      phone: z.string().nullable().optional(),
      avatar_file_id: z.number().nullable().optional(),
      avatar_url: z.string().nullable().optional(),
      role: z
        .object({
          id: z.number(),
          name: z.string(),
        })
        .nullable()
        .optional(),
      selected_company: companySchema.nullable().optional(),
      companies: z.array(companySchema),
      permissions: z.array(z.string()),
    }),
  }),
  trace_id: z.string().optional(),
});

export type Company = z.infer<typeof companySchema>;
export type LoginRequest = z.infer<typeof loginRequestSchema>;
export type LoginResponse = z.infer<typeof loginResponseSchema>;
export type ProfileResponse = z.infer<typeof profileResponseSchema>;
export type ProfileDetail = ProfileResponse["response_output"]["detail"];
